<template>
    <footer>
    </footer>
</template>

<style scoped>
    a {
        color: #333;
    }

    footer {
        background-color:  rgb(64,67,69);
        position: absolute;
        left: 0px;
        top: 1080px;
        width: 1920px;
        height: 30%;
        z-index: -1;
        overflow: hidden;
    }
</style>